export default __webpack_public_path__ + "static/media/DescriptionBox.18d9d800.svg";